"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isTaprootRecipient = exports.validateRecipient = exports.calculateFees = void 0;
const errors_1 = require("@ledgerhq/errors");
const cache_1 = require("@ledgerhq/live-network/cache");
const js_getFeesForTransaction_1 = __importDefault(require("./js-getFeesForTransaction"));
const logic_1 = require("./logic");
const wallet_btc_1 = require("./wallet-btc");
const getCacheKeyForCalculateFees = ({ a, t }) => `${a.id}_${a.blockHeight || 0}_${t.amount.toString()}_${String(t.useAllAmount)}_${t.recipient}_${t.feePerByte ? t.feePerByte.toString() : ""}_${0}_${t.utxoStrategy.strategy}_${String(t.rbf)}_${t.utxoStrategy.excludeUTXOs
    .map(({ hash, outputIndex }) => `${hash}@${outputIndex}`)
    .join("+")}`;
exports.calculateFees = (0, cache_1.makeLRUCache)(({ account, transaction }) => __awaiter(void 0, void 0, void 0, function* () {
    return (0, js_getFeesForTransaction_1.default)({
        account,
        transaction,
    });
}), ({ account, transaction }) => getCacheKeyForCalculateFees({
    a: account,
    t: transaction,
}), {
    ttl: 5 * 60 * 1000, // 5 minutes
});
exports.validateRecipient = (0, cache_1.makeLRUCache)((currency, recipient) => __awaiter(void 0, void 0, void 0, function* () {
    if (!recipient) {
        return {
            recipientError: new errors_1.RecipientRequired(""),
            recipientWarning: null,
        };
    }
    try {
        const recipientWarning = yield (0, logic_1.isValidRecipient)({
            currency,
            recipient,
        });
        return {
            recipientError: null,
            recipientWarning,
        };
    }
    catch (e) {
        return {
            recipientError: e instanceof Error ? e : null,
            recipientWarning: null,
        };
    }
}), (currency, recipient) => `${currency.id}_${recipient || ""}`);
exports.isTaprootRecipient = (0, cache_1.makeLRUCache)((currency, recipient) => __awaiter(void 0, void 0, void 0, function* () {
    return (0, wallet_btc_1.isTaprootAddress)(recipient, currency.id);
}), (currency, recipient) => `${currency.id}_${recipient || ""}`);
//# sourceMappingURL=cache.js.map